<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary justify-content-between mb-3">
      <router-link class="navbar-brand" to="/welcome">Pulse-app</router-link>

      <button
          aria-controls="navbarNavDropdown" aria-expanded="false"
          class="navbar-toggler" data-target="#navbarNavDropdown"
          data-toggle="collapse" type="button"
          aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-between" id="navbarNavDropdown">
        <ul class="navbar-nav" v-if="currentLoggedInUser">
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_USER')">
            <router-link class="nav-link" to="/dashboard">Uurrooster</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_USER')">
            <router-link class="nav-link" to="/details">Timesheet</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_USER')">
            <router-link class="nav-link" to="/configuration">Configuratie</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_USER')">
            <router-link class="nav-link" to="/userViewRecup">Recup</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewcontracts">Contracten</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewusers">Gebruikers</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewcustomers">Klanten</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewAbsences">Afwezigheden</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewvacation">Vakantiesaldo's</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewHourlyRates">Tarieven</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewinvoices">Facturen</router-link>
          </li>
          <li class="nav-item" v-if="currentLoggedInUser.roles.includes('ROLE_ADMIN')">
            <router-link class="nav-link" to="/admin/viewconfirmedemailoverview">E-mails</router-link>
          </li>
        </ul>

        <div class="nav-item dropdown" v-if="currentLoggedInUser">
          <a
              class="nav-link dropdown-toggle text-white" href="#"
              id="navbarDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
            {{ currentLoggedInUser.firstName + ' ' + currentLoggedInUser.lastName }}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <router-link class="dropdown-item" to="/profile">Profiel</router-link>
            <a class="dropdown-item" @click="logoutFromApp">Uitloggen</a>
          </div>
        </div>
      </div>
    </nav>
    <div class="container">
      <ErrorComponent v-show="isError"/>
      <WarningComponent v-show="isWarning"/>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import ErrorComponent from "./components/ErrorComponent";
import WarningComponent from "@/components/WarningComponent.vue";

export default {
  name: 'App',
  components: {WarningComponent, ErrorComponent},
  computed: {
    ...mapGetters({
      currentLoggedInUser: 'user/currentLoggedInUser',
      isError: 'isError',
      isWarning: 'isWarning'
    })
  },
  methods: {
    ...mapActions('authentication', ['logoutFromApp'])
  }

};
</script>


<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';

.actionIcon {
  cursor: pointer;
  width: 1.75rem;
  height: 1.75rem;
  vertical-align: text-bottom;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  --primary: #009490;
  .bg-primary{
    background-color: #009490 !important;
    border-bottom-color: #009490 !important;
    border-top-color: #009490 !important;
    border-left-color: #009490 !important;
    border-right-color: #009490 !important;
  }
  .btn-primary{
    background-color: #009490 !important;
    border-bottom-color: #009490 !important;
    border-top-color: #009490 !important;
    border-left-color: #009490 !important;
    border-right-color: #009490 !important;
  }

  .btn-basic {
    width: 140px;
    cursor: pointer;
    outline: 0;
    color: white;
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    border: 2px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  .btn-basic:disabled {
    opacity: 0.4;
    cursor: default;
  }
  .btn-basic:disabled:hover {
    opacity: 0.4;
    cursor: default;
  }


  .btn-outline-pulse{
    color: #009490;
    background-color: rgba(255, 255, 255, 0.9);
    border-color: rgba(0, 148, 144, 0.9);
  }

  .btn-outline-pulse:enabled:hover{
    color: white;
    background-color: #009490;
    border-color: #009490;
  }

  .btn-outline-pulse-dark{
    color: #454f4f;
    background-color: rgba(255, 255, 255, 0.9);
    border-color: rgba(69, 79, 79, 0.9);
  }

  .btn-outline-pulse-dark:enabled:hover{
    color: white;
    background-color: rgba(69, 79, 79, 0.6);
    border-color: rgba(69, 79, 79, 0.6);
  }


  .btn-fill-pulse{
    color: white;
    background-color: rgba(0, 148, 144, 0.6);
    border-color: rgba(0, 148, 144, 0.6);
  }

  .btn-fill-pulse:enabled:hover{
    color: white;
    background-color: #009490;
    border-color: #009490;
  }

  .btn-fill-pulse-dark{
    color: white;
    background-color: rgba(69, 79, 79, 0.7);
    border-color: rgba(69, 79, 79, 0.7);
  }

  .btn-fill-pulse-dark:enabled:hover{
    color: white;
    background-color: #454f4f;
    border-color: #454f4f;
  }


  .btn-blue {
    background-color: #5297ff;
  }
  .btn-blue:disabled, .btn-blue:hover:enabled {
    background-color: #3b5a86;
    border-color: #3b5a86;
  }

  .btn-red {
    background-color: #cc565f;
  }
  .btn-red:disabled, .btn-red:hover:enabled  {
    background-color: #6c353a;
    border-color: #6c353a;
  }

  .btn-green {
    background-color: #56a964;
  }
  .btn-green:disabled,.btn-green:hover:enabled {
    background-color: #38623f;
    border-color: #38623f;
  }

  .btn-dark {
    background-color: #738293;
  }
  .btn-dark:disabled, .btn-dark:hover:enabled {
    background-color: #3c444d;
    border-color: #3c444d;
  }

  .btn-purple {
    background-color: #a86ab2;
  }
  .btn-purple:disabled, .btn-purple:hover:enabled {
    background-color: #55395b;
    border-color: #55395b;
  }

  .btn-teal {
    background-color: #14b5d0;
  }
  .btn-teal:disabled, .btn-teal:hover:enabled {
    background-color: #1091a6;
    border-color: #1091a6;
  }

  .btn-gold {
    color: #383838;
    background-color: #fad351;
  }
  .btn-gold:disabled, .btn-gold:hover:enabled {
    background-color: #8c7543;
    border-color: #8c7543;
  }

  .btn-orange {
    background-color: #ffa468 ;
  }
  .btn-orange:disabled, .btn-orange:hover:enabled {
    background-color: #885d40;
    border-color: #885d40;
  }
}
</style>
